import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeService } from './services/employee.service';
import { EmpresaTreeViewService } from './services/empresa-treeView.service';
import { EmployeeStoreService } from './services/employee-store.service';
import { SharedModule } from '../common/shared.module';
import { CreateNewEmployeeComponent } from './components/create-new-employee/create-new-employee.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule, FuseWidgetModule } from '@fuse/components';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'app/angular-material.module';
import { DiagnosisService } from '../employee-view/services/diagnosis.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DireccionService } from '../employee-view/services/direccion.service';
import { EmpresaService } from '../employee-view/services/empresa.service';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';
import { AttributeComponent } from './components/attribute/attribute.component';


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY', 
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [CreateNewEmployeeComponent, AttributeComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    FuseHighlightModule,
    FuseWidgetModule,
    RouterModule,
    AngularMaterialModule,
    SharedModule,
    FuseShortcutsModule
  ],
  providers: [
    EmployeeService,
    EmpresaTreeViewService,
    EmployeeStoreService,
    DiagnosisService,
    DireccionService,
    EmpresaService,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class EmployeeModule { }
